import type { ComponentProps } from 'react';
import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { FlagTransparentIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { ReportAbuseLinkContainer as ReportAbuseLink } from '../../containers/ReportAbuseLink';

type Props = ComponentProps<typeof ReportAbuseLink>;

export const ReportAIIssueLink: React.FC<Props> = (props) => {
	return (
		<ReportAbuseLink {...props}>
			<button
				type="button"
				className="text-typography-weak m-0 mb-4 flex cursor-pointer items-center border-0 bg-transparent p-0"
			>
				{/* eslint-disable-next-line @change-ds/ds-no-arbitrary-spacing-classname */}
				<FlagTransparentIcon size={16} className="mr-[5px]" />
				<Text as="span" size="x-small" underline>
					<Translate value="fe.pages.decision_maker_show.ai_content.report_issue_label" />
				</Text>
			</button>
		</ReportAbuseLink>
	);
};
